// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1R38m","index":"styles_index__uuNos"};